<template>
  <div v-loading="loading" class="rj-page-card is-center">
    <div class="rj-page-card__title">
      项目基本信息
    </div>
    <div class="rj-page-card__content">
      <div class="rj-row">
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              CRM编号：
            </div>
            <div class="rj-baseinfo__item">
              {{ baseInfo.oppCode }}
            </div>
          </div>
        </div>
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              业务员：
            </div>
            <div class="rj-baseinfo__item">
              {{ baseInfo.saleName }}
            </div>
          </div>
        </div>
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              部门：
            </div>
            <div class="rj-baseinfo__item">
              {{ baseInfo.detpName }}
            </div>
          </div>
        </div>
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              项目名称：
            </div>
            <div class="rj-baseinfo__item">
              {{ baseInfo.documentTitle }}
            </div>
          </div>
        </div>
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              分销商：
            </div>
            <div class="rj-baseinfo__item has-contacts">
              <template v-if="baseInfo.distributorName">
                {{ baseInfo.distributorName }} <el-tag v-if="baseInfo.disServiceSubject" type="danger">
                  服务主体
                </el-tag>
              </template>
              <template v-else>
                无
              </template>
            </div>
          </div>
        </div>
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              首级集成商：
            </div>
            <div class="rj-baseinfo__item">
              <template v-if="baseInfo.integratorsName">
                {{ baseInfo.integratorsName }} <el-tag v-if="baseInfo.integratorsSubject" type="danger">
                  服务主体
                </el-tag> <contacts :id="baseInfo.integratorsCode" />
              </template>
              <template v-else>
                无
              </template>
            </div>
          </div>
        </div>
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              末级集成商：
            </div>
            <div class="rj-baseinfo__item">
              <template v-if="baseInfo.finalIntegratorsName">
                {{ baseInfo.finalIntegratorsName }} <el-tag v-if="baseInfo.finalIntegratorsSubject" type="danger">
                  服务主体
                </el-tag>
              </template>
              <template v-else>
                无
              </template>
            </div>
          </div>
        </div>
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              计量集成商：
            </div>
            <div class="rj-baseinfo__item">
              <template v-if="baseInfo.measureIntegratorName">
                {{ baseInfo.measureIntegratorName }} <el-tag v-if="baseInfo.measureIntegratorSubject" type="danger">
                  服务主体
                </el-tag>
              </template>
              <template v-else>
                无
              </template>
            </div>
          </div>
        </div>
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              最终客户：
            </div>
            <div class="rj-baseinfo__item">
              {{ baseInfo.crmaccountName }}
            </div>
          </div>
        </div>
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              A类产品服务商：
            </div>
            <div class="rj-baseinfo__item">
              <template v-if="baseInfo.aserviceName">
                {{ baseInfo.aserviceName }} <el-tag v-if="baseInfo.aisServerSubject" type="danger">
                  服务主体
                </el-tag>
              </template>
              <template v-else>
                无
              </template>
            </div>
          </div>
        </div>
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              B类产品服务商：
            </div>
            <div class="rj-baseinfo__item has-contacts">
              <template v-if="baseInfo.bserviceName">
                {{ baseInfo.bserviceName }} <el-tag v-if="baseInfo.bisServerSubject" type="danger">
                  服务主体
                </el-tag> <contacts v-if="baseInfo.integratorsSubject" :id="baseInfo.bserviceCode" />
              </template>
              <template v-else>
                无
              </template>
            </div>
          </div>
        </div>
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              C类产品服务商：
            </div>
            <div class="rj-baseinfo__item has-contacts">
              <template v-if="baseInfo.cserviceName">
                {{ baseInfo.cserviceName }} <el-tag v-if="baseInfo.cisServerSubject" type="danger">
                  服务主体
                </el-tag> <contacts v-if="baseInfo.integratorsSubject" :id="baseInfo.cserviceCode" />
              </template>
              <template v-else>
                无
              </template>
            </div>
          </div>
        </div>
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              是否为此项目服务主体：
            </div>
            <div class="rj-baseinfo__item">
              {{ baseInfo.thisObejctSubject?'是':'否' }}
            </div>
          </div>
        </div>
        <div v-if="baseInfo.thisObejctSubject" class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              服务主体利润：
            </div>
            <div class="rj-baseinfo__item">
              {{ baseInfo.serviceSubjectProfit }}元
            </div>
          </div>
        </div>
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              销售模式：
            </div>
            <div class="rj-baseinfo__item">
              {{ baseInfo.saleModesName }}
            </div>
          </div>
        </div>
        <div class="rj-col-3">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              备注：
            </div>
            <div class="rj-baseinfo__item">
              {{ baseInfo.specialProductDesc }}
            </div>
          </div>
        </div>
        <div v-if="baseInfo.thisObejctSubject" class="rj-col-1">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              服务主体说明：
            </div>
            <div class="rj-baseinfo__item">
              {{ baseInfo.serverSubjectNotes }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="rj-page-card__title" style="margin-top: 10px">
      产品明细
    </div>
    <div class="rj-page-card__content">
      <div class="miaoshu">
        <div class="tip rj-flex">
          <div>
            注：
          </div>
          <div class="rj-flex__item">
            <p>1、订单供货期规则（下单生成时间至要货时间）：仅含中低端产品：7天；高端产品：14天；定制化产品 / 按单产品 / 受控产品：单独与平台商务或供应链沟通确认。</p>
            <p>2、服务主体职责：负责输出项目的方案设计，项目管理，对项目的全过程负责。</p>
            <p v-if="isShowTips">
              3、涉及服务费后返订单，服务主体提供方按照要求完成对客户的服务交付后，将通过技能培育费用给与服务主体激励。
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script type="es6">
import Contacts from '@/components/Contacts';
import { getBaseOrderDetailInfo } from '@/API';
export default {
  data () {
    return {
      loading: false,
      baseInfo: {}
    };
  },
  props: {
    // 数据由父组件传递
    documentID: {
      type: String,
      required: true
    }
  },
  components: {
    Contacts
  },
  computed: {
    isShowTips () {
      return this.baseInfo.deptCode ? this.baseInfo.deptCode.startsWith('000062') : false;
    }
  },

  methods: {
    initData () {
      this.loading = true;
      let params = {
        documentID: this.documentID,
        newEcpFlag: this.$route.query.newEcpFlag
      };
      getBaseOrderDetailInfo(params).then((res) => {
        let json = res.data;
        this.loading = false;
        if (json.status === '200') {
          this.baseInfo = json.data;
          this.$emit('initedBaseInfo', json.data);
        }
      }).catch(() => {
        this.loading = false;
      });
    }
  },
  mounted () {
    this.initData();
  }
};
</script>
<style lang="scss">
  @import "../../../../style/var";
  .miaoshu{
    line-height: 30px;
    .tip{
      color: $--color-text-secondary;
      font-size: 13px;
    }
  }
</style>
